import { TableCell, TableRow } from "@/components/ui/table";
import { flexRender, Table } from "@tanstack/react-table";
import { AppSessionsTableType } from "../types/appSession.type";
import { columns } from "./AppSessionsColumns";

interface Props<TData> {
  table: Table<TData>;
  limitRenderedRowsNumber: number;
}

export function AppSessionsTableBody<TData extends AppSessionsTableType>({
  table,
  limitRenderedRowsNumber
}: Props<TData>) {
  return table.getRowModel().rows?.length ? (
    table
      .getRowModel()
      .rows.slice(0, limitRenderedRowsNumber)
      .map((row) => (
        <TableRow key={row.id} className="h-16 group">
          {row.getVisibleCells().map((cell) => (
            <TableCell key={cell.id}>
              {cell.getIsGrouped() && (
                <button
                  className="flex"
                  onClick={() => row.toggleExpanded()}
                  style={{
                    cursor: row.getCanExpand() ? "pointer" : "auto"
                  }}
                >
                  {row.getIsExpanded() ? "▼" : "►"}
                  {flexRender(cell.column.columnDef.cell, cell.getContext())} (
                  {row.subRows.length})
                </button>
              )}
              {cell.getIsAggregated() &&
                flexRender(
                  cell.column.columnDef.aggregatedCell ??
                    cell.column.columnDef.cell,
                  cell.getContext()
                )}
              {!cell.getIsGrouped() &&
                !cell.getIsAggregated() &&
                !cell.getIsPlaceholder() &&
                flexRender(cell.column.columnDef.cell, cell.getContext())}
            </TableCell>
          ))}
        </TableRow>
      ))
  ) : (
    <TableRow>
      <TableCell colSpan={columns.length} className="h-16 text-center">
        No results.
      </TableCell>
    </TableRow>
  );
}
